<div class="flex-parent">
  <div class="login-form-div">
    <mat-icon class="really-big-icon unselectable" >info</mat-icon>
    <div class="header">
      <h3 class="text-details">
        {{'About.title' | translate}}
      </h3>
    </div>
    <div class="about-info">
      <table class="invisible-table">

        <tr>
          <td class="info-text">{{'About.authService' | translate}}</td>
          <td class="info-text">{{versionInfo}}</td>
        </tr>
        <tr>
          <td class="info-text">{{'About.frameworks' | translate}}</td>
          <td class="info-text"> {{frameworkVersionsInfo}}</td>
        </tr>
      </table>
    </div>
    <div class="additional-options">
      <app-back-button></app-back-button>
    </div>
  </div>
</div>
